import {Link} from "react-router-dom";
import {Space, Breadcrumb, Row, Col, Divider} from 'antd';
import JobNew from "../components/JobNew";


export default function PageNew() {

    return (
        <>
                <Row gutter={16}>
                    <Col className="gutter-row" span={24}>
                        <Breadcrumb
                            items={[
                                {
                                    title: <Link to={'/'}>Dashboard</Link>,
                                },
                                {
                                    title: 'New job',
                                },
                            ]}
                        />
                    </Col>
                </Row>
            <Divider/>
                <Row gutter={16}>
                    <Col className="gutter-row" span={24}>
                        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                        <JobNew />
                        </Space>
                    </Col>
                </Row>
        </>
    );
}